// extracted by mini-css-extract-plugin
export default {"addButton":"addRepairInvoice_addButton__0vCvO","container":"addRepairInvoice_container__dA608","form":"addRepairInvoice_form__oeCL6","buttons":"addRepairInvoice_buttons__FWJrg"};